import React, {
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import { getRandomId } from '@common/utils';

const SatFollowText = forwardRef((props, ref) => {
  const {
    isTextarea = false,
    isErrorVisible = false,
    followText = '',
    complete = false,
    onMatched = undefined,
    onPressEnter = undefined,
    className,
  } = props;

  const inputRef = useRef();
  const [followTextId] = useState(getRandomId());
  const [inputText, setInputText] = useState('');
  const [isMatched, setIsMatched] = useState(undefined);

  useImperativeHandle(ref, () => ({
    // 입력값 match 여부
    getIsMatched() {
      if (!isMatched) setIsMatched(false);
      return isMatched;
    },
    // input focus
    onFocusInput() {
      inputRef.current.focus();
    },
    // input blur
    onFocusBlur() {
      inputRef.current.blur();
    },
  }));

  useEffect(() => {
    if (complete && followText) {
      setInputText(followText);
      setIsMatched(true);
    }
  }, [complete, followText]);

  useEffect(() => {
    if (inputText === followText) setIsMatched(true);
  }, [inputText]);

  useEffect(() => {
    if (isMatched) onMatched && onMatched(isMatched, followTextId);
  }, [isMatched]);

  const handleFollowText = e => {
    const value = e.target.value;
    const cleanedValue = value.replace(/\n/g, '');

    if (!isMatched) {
      if (isEqual(cleanedValue)) {
        setInputText(followText);
      } else {
        setInputText(cleanedValue);
      }
    }
  };

  const isEqual = inputValue => {
    return (
      inputValue.replaceAll(/\s/gi, '').toUpperCase() ===
      followText.replaceAll(/\s/gi, '').toUpperCase()
    );
  };

  const handleKeyDown = e => {
    // 엔터키 방지
    if (e.keyCode === 13) {
      e.preventDefault();

      onPressEnter && onPressEnter();
    }
  };

  const handleFollowBlur = () => {
    if (inputText !== followText) {
      setIsMatched(false);
    }
  };

  const handleFollowFocus = () => {
    if (!isEqual(inputText)) setIsMatched(undefined);
  };

  return (
    <div
      id={followTextId}
      className={$classNames('follow-text intxt mgl-0', {
        matched: isMatched,
        error: isMatched === false || (!isMatched && isErrorVisible),
      })}
    >
      {isTextarea ? (
        <>
          <div>{followText}</div>

          <textarea
            ref={inputRef}
            value={inputText}
            onKeyDown={handleKeyDown}
            onBlur={handleFollowBlur}
            onFocus={handleFollowFocus}
            onChange={handleFollowText}
            className={className}
            spellCheck="false"
          />
        </>
      ) : (
        <>
          <span>{followText}</span>

          <input
            ref={inputRef}
            type="text"
            value={inputText}
            onKeyDown={handleKeyDown}
            onBlur={handleFollowBlur}
            onFocus={handleFollowFocus}
            onChange={handleFollowText}
            className={className}
            spellCheck="false"
          />
        </>
      )}
    </div>
  );
});

export default React.memo(SatFollowText);
